import './technics.scss';
import './img/c-technics-1.png';
import './img/c-technics-2.png';
import './img/c-technics-3.png';
import './img/c-technics-4.png';
import './img/bg-technics.png';

